<template>
  <h2 class="text-3xl font-500 px-5 py-6 md:pt-10">{{ props.title }}</h2>
</template>

<script lang="ts" setup>
interface Props {
  title: string
}

const props = defineProps<Props>()
</script>
